/**
 * Drupal behavior to process paragraph text links.
 *
 * This behavior applies a specific class to anchor (`<a>`) elements within
 * paragraph content that do not already have a class and whose text content
 * matches a URL pattern (starting with "http://" or "https://").
 *
 * @namespace Drupal.behaviors.AutryParagraphText
 * @property {Function} attach - Attaches the behavior to the specified context.
 * @param {HTMLElement|Document} context - The context within which to apply the behavior.
 *
 * @example
 * // Example usage:
 * // Links within the `.paragraph-content` element that match the criteria
 * // will have the `long-url` class added to them.
 *
 * // HTML:
 * // <div class="paragraph-content">
 * //   <a href="https://example.com">https://example.com</a>
 * //   <a href="https://example.com" class="existing-class">https://example.com</a>
 * // </div>
 *
 * // Result:
 * // <div class="paragraph-content">
 * //   <a href="https://example.com" class="long-url">https://example.com</a>
 * //   <a href="https://example.com" class="existing-class">https://example.com</a>
 * // </div>
 */
Drupal.behaviors.AutryParagraphText = {
  attach: function (context) {
    const links = once(
      'AutryParagraphText',
      '.paragraph-content a:not([class])',
      context
    )
    links.forEach(link => {
      const text = link.textContent
      if (/^(https?:\/\/)/.test(text)) {
        link.classList.add('long-url')
      }
    })
  }
}
